if (!window.Maximize.loadedScript.includes('variant-picker.js')) {
  window.Maximize.loadedScript.push("variant-picker.js");

  class VariantPicker extends HTMLElement {
    static cacheData = {};
    constructor() {
      super();
      this.pickerType = this.dataset.pickerType || 'swatch';
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.url;
      this.isMainProduct = this.dataset.mainProduct === 'true';
      this.optionElements = this.querySelectorAll(`.variant-option`);
      this.optionLabelElements = Array.from(this.querySelectorAll(`.variant-option__label`));
      this.optionsSelectedValues = [];
      this.isEnableStickyATC = this.dataset.enableStickyAtc === 'true';
      this.currentVariantInfoElement = document.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      this.addtionalCurrentVariantInfoElement = document.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      this.currentVariant = JSON.parse(this.currentVariantInfoElement.textContent);
      this.sectionWrapper = document.getElementById(`shopify-section-${this.sectionId}`);
      const variantsDataElement = this.querySelector('[data-product-variants]');
      this.variantsData = variantsDataElement ? JSON.parse(variantsDataElement.textContent) : [];
      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    connectedCallback() {
      this.optionElements.forEach(el => {
        el.addEventListener('click', this.handleChangedOption.bind(this));
        if (this.type === 'dropdown') {
          el.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              el.click();
            }
          })
        }
      })

      this.optionLabelElements.forEach(el => {
        el.addEventListener('keyup', el => {
          if (el.key === 'Enter' || el.key === ' ') {
            let optionInput = el.target.previousElementSibling;
            optionInput.click();
          }
        })
      })

      this.updateOptionSelectedValues();

      if (this.isEnableStickyATC) {
        this.__initEventSticky();
      }

      // Shopify already opens on the first available variant when none is requested. A
      // requested variant (?variant= on the product page, the card's variant in quick view)
      // is kept even when sold out so its availability shows; only an unrequested sold out
      // variant is replaced.
      const isRequestedVariant = !this.isMainProduct
        || new URLSearchParams(window.location.search).get('variant') === String(this.currentVariant?.id);
      if (this.currentVariant && !this.currentVariant.available && !isRequestedVariant) {
        const firstAvailableVariant = this.variantsData.find(variant => variant.available);
        if (firstAvailableVariant) {
          firstAvailableVariant.options.forEach((value, index) => {
            const optionEle = this.__getOptionElements(index + 1).find(el => el.dataset.value === value);
            if (optionEle) this.__setSelectedOption(optionEle);
          });
          this.updateOptionSelectedValues();
          this.__renderProductInfo();
        }
      }
    }

    handleChangedOption(event) {
      const targetOption = event.currentTarget;

      // Unavailable values stay visible but cannot be selected
      if (targetOption.classList.contains('disabled')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      this.__setSelectedOption(targetOption);
      this.__selectAvailableOptions(Number(targetOption.dataset.optionPosition));

      this.updateOptionSelectedValues();
      this.__renderProductInfo();
    }

    __getOptionElements(position) {
      return Array.from(this.querySelectorAll(`.variant-option[data-option-position='${position}']`));
    }

    __setSelectedOption(targetOption) {
      let position = targetOption.dataset.optionPosition;
      this.__getOptionElements(position).forEach(optionEle => {
        optionEle.classList[optionEle === targetOption ? 'add' : 'remove']('selected');
        optionEle.setAttribute("aria-selected", String(optionEle === targetOption));
        if (optionEle.type === 'radio') optionEle.checked = optionEle === targetOption;
      });
      const selectedOptionEle = this.querySelector(`.variant-option__selected-value[data-position='${position}']`);
      if (selectedOptionEle) {
        (targetOption.dataset.optionName == 'Size' || targetOption.dataset.optionName == 'Taille') ? 
          selectedOptionEle.innerHTML = targetOption.dataset.value :
          selectedOptionEle.innerHTML = targetOption.dataset.value.toLowerCase()
                                        .split(' ')
                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                        .join(' ');
      }
    }

    // For every option after `changedPosition`, keep the selected value if it is still available
    // with the preceding selections, otherwise select the first available value (e.g. first size in stock for the new color).
    __selectAvailableOptions(changedPosition) {
      if (this.variantsData.length === 0) return;

      const optionCount = this.variantsData[0].options.length;
      const selectedValues = [];
      for (let position = 1; position <= optionCount; position++) {
        selectedValues.push(this.querySelector(`.variant-option.selected[data-option-position='${position}']`)?.dataset.value);
      }

      for (let position = changedPosition + 1; position <= optionCount; position++) {
        const index = position - 1;
        const availableVariants = this.variantsData.filter(variant =>
          variant.available && selectedValues.slice(0, index).every((value, i) => variant.options[i] === value)
        );
        const isAvailable = optionEle => availableVariants.some(variant => variant.options[index] === optionEle.dataset.value);
        const optionElements = this.__getOptionElements(position);
        const currentOption = optionElements.find(optionEle => optionEle.dataset.value === selectedValues[index]);
        if (currentOption && isAvailable(currentOption)) continue;

        const firstAvailableOption = optionElements.find(isAvailable);
        if (!firstAvailableOption) break;
        this.__setSelectedOption(firstAvailableOption);
        selectedValues[index] = firstAvailableOption.dataset.value;
      }
    }

    updateOptionSelectedValues() {
      this.optionElements.forEach((optionEle) => {
        const optionPosition = optionEle.dataset.optionPosition;
        const idx = Number(optionPosition) - 1;
        if (optionEle.classList.contains('selected')) {
          this.optionsSelectedValues[idx] = optionEle.dataset.optionValueId;
        }
      });
    }

    async __renderProductInfo() {
      const buyButtonList = this.sectionWrapper.querySelectorAll(".product-info__buy-buttons-wrapper button")
      buyButtonList.forEach(button => {
        button.disabled = true
      });
      const url = `${this.productUrl}?option_values=${this.optionsSelectedValues.join(',')}&section_id=${this.sectionId}`;
      let productInfoHTML = VariantPicker.cacheData[url];
      if (!productInfoHTML) {
        try {
          const response = await fetch(url);
          const text = await response.text();
          productInfoHTML = new DOMParser().parseFromString(text, "text/html")
          VariantPicker.cacheData[url] = productInfoHTML;
        } catch (error) {
          console.error(error)
        }
      }

      const newVariantPickerEle = productInfoHTML.querySelector(`.section--${this.sectionId} variant-picker.variant-picker__wrapper`);
      this.dataset.currentVariantId = newVariantPickerEle?.dataset.currentVariantId || '';
      const variantId = this.dataset.currentVariantId;

      if (this.isMainProduct) {
        if (variantId.length > 0){
          window.history.replaceState({}, "", `${this.productUrl}?variant=${variantId}`);
        } else {
          window.history.replaceState({}, "", `${this.productUrl}`);
        }
      }
      this.__updateCurrentVariantInfo(productInfoHTML);
      if (this.currentVariant) {
        const _upc = document.querySelectorAll(`[data-parent-id="${this.productId}"][name="properties[_upc]"]`);
        if(_upc && this.currentVariant?.barcode && _upc.length > 0)
        Array.from(_upc).forEach(input => { input.value = this.currentVariant.barcode; });

        const _compare_at_price = document.querySelectorAll(`[data-parent-id="${this.productId}"][name="properties[_compare_at_price]"]`);
        if(_compare_at_price && this.currentVariant?.compare_at_price && _compare_at_price.length > 0)
        Array.from(_compare_at_price).forEach(input => { input.value = '$'+(this.currentVariant.compare_at_price / 100).toFixed(2); });

        const _price = document.querySelectorAll(`input[data-parent-id="${this.productId}"][name="properties[_price]"]`);
        if(_price && this.currentVariant?.price && _price.length > 0)
        Array.from(_price).forEach(input => { input.value = '$'+(this.currentVariant.price / 100).toFixed(2); });
        
        const selectors = [
          // ".product-info__variant-picker", // update price
          ".product-info__price-wrapper", // update price
          ".product-info__identifier-wrapper", // update sku, barcode
          ".product-info__estimate-delivery-wrapper", // update estimate delivery
          ".product-info__quantity-wrapper", // update quantity selector
          ".product-info__label-wrapper", // update labels
          ".product-info__inventory-status-wrapper", // update inventory status
          ".product-info__back-in-stock-alert-wrapper", // update back in-stock alert
          ".product-template__properties" // update properties of the product
        ];
        const selectorsUpdateWhenAvailable = [
          '.product-info__estimate-delivery-wrapper',
          '.product-info__rating',
          '.product-info__label-wrapper',
          '.product-form__dynamic-checkout',
          `#PickupAvailability__${this.sectionId}`
        ]

        selectors.forEach(selector => {
          this.__updateElements(productInfoHTML, selector);
        });

        this.__updateTableOfInformation(productInfoHTML)

        selectorsUpdateWhenAvailable.forEach(selector => {
          const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
          if (element) {
            element.classList.remove('is-unavailable');
          }
        })
      } else {
        this.__renderProductInfoWhenUnavailable();
      }

      this.__updateVariantPickerWhenChange(productInfoHTML);

      buyButtonList.forEach(button => {
        if (!button.ariaDisabled) {
          button.disabled = false;
        }
      });
      
      this.__dispatchChangeVariantEvent(productInfoHTML);

      if (this.isEnableStickyATC) {
        this.__renderStickyATC(productInfoHTML);
      }
    }

    __updateElements(productInfoHTML, selector) {
      const oldElement = document.querySelector(`.section--${this.sectionId} ${selector}`);
      const newElement = productInfoHTML.querySelector(`.section--${this.sectionId} ${selector}`);
      if (oldElement && newElement) {
        oldElement.innerHTML = newElement.innerHTML;
        if (oldElement.classList.contains('is-unavailable')) {
          oldElement.classList.remove('is-unavailable');
        }
      }
    }

    __updateTableOfInformation(productInfoHTML) {
      const selector = ".table-content__row__last";
      const oldElements = document.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      const newElements = productInfoHTML.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      oldElements.forEach((oldEle, index) => {
        if (newElements[index]) {
          oldEle.innerHTML = newElements[index].innerHTML;
        }
      });
    }

    __updateVariantPickerWhenChange(productInfoHTML) {
      this.optionElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .variant-option[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
          el.checked = newOptionEle.classList.contains('selected');

          el.innerHTML = newOptionEle.innerHTML;
          el.dataset.selectValue = newOptionEle.dataset.selectValue;
        }
      })

      this.optionLabelElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .variant-option__label[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
        }
      })

      // fix for the dropdown type
      const listSelectElementLabels = this.querySelectorAll(`.select-button__label.variant-option__select-button__label`);
      listSelectElementLabels.forEach(el => {
        const position = el.dataset.optionPosition;
        const newEl = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .select-button__label.variant-option__select-button__label[data-option-position="${position}"]`);
        if (newEl) {
          el.innerHTML = newEl.innerHTML.trim();
        }
      })

      const oldListSwatch = document.querySelectorAll(`.section--${this.sectionId} .swatch-option__label`);
      if (oldListSwatch.length > 0) {
        oldListSwatch.forEach((swatch) => {
          const optionId = swatch.getAttribute('for');

          const newSwatchLabel = productInfoHTML.querySelector(`.swatch-option__label[for=${optionId}]`)

          if (newSwatchLabel) {
            if (newSwatchLabel.dataset.swatchStyle === 'image') {
              swatch.style.setProperty('--swatch-image-value', newSwatchLabel.dataset.swatchValue);
            } else if (newSwatchLabel.dataset.swatchStyle === 'color') {
              swatch.style.setProperty('--swatch-color-value', newSwatchLabel.dataset.swatchValue);
            }
          }
        });
      }
    }

    __renderStickyATC (productInfoHTML) {
      const selectors = [
        `#StickyAddToCart__Image__${this.sectionId}`,
        `#StickyAddToCart__Variant__${this.sectionId}`,
        `#StickyAddToCart__Price__${this.sectionId}`,
        `.sticky-add-to-cart__form`
      ];

      selectors.forEach(selector => {
        this.__updateElements(productInfoHTML, selector);
      });
    }

    __initEventSticky() {
      document.addEventListener(`${STICKY_ATC_EVENT.optionChange}-${this.sectionId}`, (event) => {
        if (event.detail.optionsSelectedValues) {
          // Apply the sticky selection to this picker so the same availability rules are used
          let changedPosition = 0;
          event.detail.optionsSelectedValues.forEach((optionValueId, index) => {
            const optionEle = this.querySelector(`.variant-option[data-option-value-id="${optionValueId}"]`);
            if (optionEle && !optionEle.classList.contains('selected')) {
              this.__setSelectedOption(optionEle);
              if (!changedPosition) changedPosition = index + 1;
            }
          });
          if (changedPosition) this.__selectAvailableOptions(changedPosition);
          this.updateOptionSelectedValues();
          this.__renderProductInfo();
        }
      })
    }

    __updateCurrentVariantInfo(productInfoHTML) {
      const newCurrentVariantInfoElement = productInfoHTML.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      if (newCurrentVariantInfoElement) {
        this.currentVariantInfoElement.textContent = newCurrentVariantInfoElement.textContent;
        this.currentVariant = JSON.parse(newCurrentVariantInfoElement.textContent);
      }

      // Store availability is computed in Liquid (store-availability-list.liquid), just swap the rendered HTML
      const newStoreAvailabilityElement = productInfoHTML.querySelector(`#StoreAvailabilityList__${this.sectionId}`);
      const storeAvailabilityElement = document.getElementById(`StoreAvailabilityList__${this.sectionId}`);
      if (newStoreAvailabilityElement && storeAvailabilityElement) {
        storeAvailabilityElement.innerHTML = newStoreAvailabilityElement.innerHTML;
      }
      const newAdditionalCurrentVariantInfoElement = productInfoHTML.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      if (newAdditionalCurrentVariantInfoElement) {
        this.addtionalCurrentVariantInfoElement.textContent = newAdditionalCurrentVariantInfoElement.textContent;
      }
      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    __renderProductInfoWhenUnavailable() {
      const selectors = [
        // ".product-info__variant-picker", // update price
        ".product-info__price-wrapper", // update price
        ".product-info__identifier-wrapper", // update sku, barcode
        ".product-info__estimate-delivery-wrapper", // update estimate delivery
        ".product-info__label-wrapper", // update labels
        ".product-info__inventory-status-wrapper", // update inventory status
        ".product-info__rating", // update rating
        `#PickupAvailability__${this.sectionId}`
      ];

      selectors.forEach(selector => {
        const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
        if (element) {
          element.classList.add('is-unavailable');
        }
      });
    }

    __dispatchChangeVariantEvent(updatedHTML) {
      document.dispatchEvent(
        new CustomEvent(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, {
          bubbles: true,
          detail: {
            productId: this.productId,
            currentVariant: this.currentVariant,
            sectionId: this.sectionId,
            isOptionAvailable: this.isOptionAvailable,
            isOptionExist: this.isOptionExist,
            previewMediaId: this.dataset.mediaId,
            optionsSelectedValues: this.optionsSelectedValues,
            updatedHTML: updatedHTML
          },
        })
      );
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
}
